import { ErrorHandler, inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class ErrorNotificationService implements ErrorHandler {
    private messageService = inject(MessageService);

    handleError(error: Error): void {
        console.error('Application Error:', error);
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.message || 'An unexpected error occurred',
            life: 5000
        });
    }
}
